import {
  AfterViewInit,
  Directive,
  ElementRef,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { DashboardNodeComponent } from './dashboard-node.component';
import { DOMEvent, ViewSelector } from './dom.constant';
import { Navigation } from '../core/dashboard.node';

@Directive()
export abstract class NavigationComponent
  extends DashboardNodeComponent<Navigation>
  implements AfterViewInit
{
  @ViewChildren(ViewSelector.NAVIGATION, { read: ElementRef })
  protected navigations!: QueryList<ElementRef>;
  private listeningToDragEvents!: boolean;
  private timeout: any;

  ngAfterViewInit(): void {
    this.listenToDragEventsIfEditMode();
  }

  protected listenToDragEventsIfEditMode(): void {
    if (this.editMode && !this.listeningToDragEvents) {
      this.navigations?.forEach((el: ElementRef) => {
        el.nativeElement?.addEventListener(
          DOMEvent.DRAG_ENTER,
          ($event: Event) => {
            $event.stopPropagation();
            this.timeout = setTimeout(() => {
              this.node.selectNavigation(el.nativeElement.id);
            }, this.dragFocusTimeout);
          }
        );

        el.nativeElement?.addEventListener(
          DOMEvent.DRAG_LEAVE,
          ($event: Event) => {
            $event.stopPropagation();
            clearTimeout(this.timeout);
          }
        );
      });

      this.listeningToDragEvents = true;
    }
  }
}
